import container from './MaintainUserModal.container';

export default container;
